import TransferenciaSalida from "./TransferenciaSalida";
export default TransferenciaSalida;